import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  CheckInFormData,
  CheckInNavigationService,
  generateUUID
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import {
  colorCodes,
  Colors_s,
  Flyout
} from '../../models/constants/today.constants';
import {
  FlightStatus,
  FlyoutToday,
  Message,
  TextColorCodes
} from '../../models/interfaces/today.models';
import { FlyoutTodayExtendedComponent } from './flyout-today-extended.component';
@Component({
  selector: 'idp-flyout-today',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flyout-today.component.html',
  styleUrls: ['./flyout-today.component.scss']
})
export class FlyoutTodayComponent
  extends FlyoutTodayExtendedComponent
  implements OnInit, AfterViewInit
{
  @Input() content: FlyoutToday = {} as FlyoutToday;
  @ViewChild('flyoutTodayMytripsForm') flyoutTodayMytripsForm!: ElementRef;
  checkInNavigationService = inject(CheckInNavigationService);
  _el = inject(ElementRef);
  ngOnInit(): void {
    this.showIropModel = this.content.showIropModel;
  }

  ngAfterViewInit(): void {
    this.showBanner(this.content);
  }

  showGreenAeroStatus = (colorCode: string): boolean =>
    this.getAeroStatusType(colorCode) === Colors_s.green;

  showOrangeAeroStatus = (colorCode: string): boolean =>
    this.getAeroStatusType(colorCode) === Colors_s.orange;

  showRedAeroStatus = (colorCode: string): boolean =>
    this.getAeroStatusType(colorCode) === Colors_s.red;

  showNoShow(flightStatus: FlightStatus): boolean {
    return flightStatus &&
      flightStatus.status &&
      flightStatus.status.toLowerCase().indexOf('not') === -1
      ? false
      : true;
  }

  getStatusTextColorChange(colorCode: string): string {
    const bgClass =
      colorCodes[colorCode.toUpperCase() as keyof TextColorCodes] ??
      colorCodes.GREEN;
    return bgClass;
  }

  mytripsTodayClick(viewTripDetailsOpenNewTab: boolean): void {
    this.flyoutTodayMytripsForm.nativeElement.target = viewTripDetailsOpenNewTab
      ? '_blank'
      : '_self';
    this.flyoutTodayMytripsForm.nativeElement.action =
      this.content.tripLinkFormAction;
    this.flyoutTodayMytripsForm.nativeElement.submit();
  }

  onSubmit(e: Event): void {
    if (this.content.tripLinkFormAction) {
      (e.target as HTMLFormElement).submit();
    }
  }

  findAlternateFlight = (rebook = false, defaultMessage?: Message): void => {
    const cacheKey = generateUUID();
    sessionStorage.setItem(
      'search_request',
      JSON.stringify({
        inputvalue: this.content?.todayTrip?.recordLocator,
        firstName: this.content?.todayTrip?.firstName,
        lastName: this.content?.todayTrip?.lastName,
        tab: 'confirmationNo'
      })
    );
    sessionStorage.setItem(
      `postData-${cacheKey}`,
      JSON.stringify({
        recordLocator: this.content?.todayTrip?.recordLocator,
        firstName: this.content?.todayTrip?.firstName,
        lastName: this.content?.todayTrip?.lastName
      })
    );
    const openNewTab = this.content?.findAlternateOpenNewTab
      ? '_blank'
      : '_self';

    if (rebook) {
      window.open(
        `${
          this.content.todayTrip?.findOtherFlights ||
          '/flightsearch/find-alternative-flights'
        }?cacheKeySuffix=${cacheKey}`,
        openNewTab
      );
    } else {
      this.showDefaultMessage(defaultMessage);
    }
  };

  closeIropModel(): void {
    this.showIropModel = false;
    const element = this._el.nativeElement.querySelector(
      '.flyout_today__irop-flyout-close'
    );
    if (element) {
      element.focus();
    }
  }

  navigateToCheckin(openNewTab: boolean, url: string) {
    const checkInFormData: CheckInFormData = {
      searchType: Flyout.SEARCH_TYPE,
      confirmationNumber: this.content.todayTrip?.recordLocator,
      lastName: this.content.todayTrip?.lastName,
      departureAirport: this.content.todayTrip?.departureCityCode,
      startFrom: Flyout.MY_DELTA
    };
    this.checkInNavigationService.navigateToCheckInFindPNR(
      checkInFormData,
      url,
      openNewTab
    );
  }
}
